import styled from 'styled-components'

import { Flex } from '@/ui/atoms/flex'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const ROUNDED_DESKTOP_WIDTH = '18rem'
const DEFAULT_DESKTOP_WIDTH = '20rem'

export const SrpSortWrapper = styled.div<{
  isMapView?: boolean
  isRoundedSelect?: boolean
}>(
  ({ theme, isRoundedSelect, isMapView }) => `
  height: auto;
  width: auto;
  display: ${isMapView ? 'none' : 'block'};

  ${MEDIA_QUERIES(theme).medium}{
    display: block;
    width: ${isRoundedSelect ? ROUNDED_DESKTOP_WIDTH : DEFAULT_DESKTOP_WIDTH};
  }
`
)

export const SrpResultsSortActions = styled.div<{
  availableActionsLength: number

  isMapView?: boolean
}>(
  ({ theme, availableActionsLength, isMapView }) => `
  align-items: flex-start;
  gap: ${theme.spacing.default};
  grid-template-columns: ${availableActionsLength > 1 ? 'auto auto' : 'auto'};
  justify-content: flex-end;

  display: grid;
  ${isMapView ? 'grid-template-columns: 1fr;' : ''}

  ${MEDIA_QUERIES(theme).medium} {
    display: grid;
    flex-grow: 1;
    gap: ${theme.spacing.defaultSmall};
    grid-template-columns: auto 1fr;
  }
`
)

export const SrpResultsSortContainer = styled.div<{
  isMapView?: boolean
}>(
  ({ theme, isMapView }) => `
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  gap: ${theme.spacing.default};
  max-height: 4rem;

 ${isMapView ? 'justify-content: flex-end;' : ''};

  ${MEDIA_QUERIES(theme).medium} {
    display: grid;
    grid-template-columns: auto min-content;
    justify-content: ${isMapView ? 'flex-end' : 'space-between'};
    gap: ${isMapView ? '0' : theme.spacing.default};
  }
`
)

export const SrpResultsCountContainer = styled.div`
  align-items: center;
  display: flex;
  height: 4rem;
`

export const SaveSearchWrapper = styled(Flex)(
  ({ theme }) => `
  width: 50%;
  margin-right: 1rem;
  margin-top: ${theme.spacing.default};

  ${MEDIA_QUERIES(theme).large} {
    display: none;
  }

  div:first-child  {
    padding:0;
    width: 100%;
  }
`
)
